export const adaptContentOrder = (data: IContentOrder): ContentOrder => {
	return {
		id: data.id,
		contentType: data.content_type,
		order: data.ordering,
		isPublished: data.is_published
	};
};

export const adaptContentOrders = (data: IContentOrder[]): ContentOrder[] => {
	return data.map(adaptContentOrder);
};
